import React, { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { getPermission} from '../../../Conexiones/Conexion';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { successToast, errorToast, errorMessage, warningToast, warningModal } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function SubActividades() {
    const [subActividades, setsubActividades] = useState([]);
    const [nombreCat, setNombreCat] = useState();
    const navigate = useNavigate();
    const num=parseInt(sessionStorage.getItem("catAct"));
    const [busqueda, setBusqueda] = useState("");
    const [tablaAct, setTablaAct] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isLoading,setIsLoading]=useState(false);
    const uri = 'subActividades/';

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nombre, setNombre] = useState("");
    const [unidad, setUnidad] = useState("");
    const [unidades,setUnidades]=useState([])
    const [listSub,setListSub]=useState([])
    const [isSaving, setSaving] = useState(false);

    //EDITAR
    const [editNombre,setEditNombre] = useState ()
    const [idUnidad,setidUnidad]=useState()
    const [idCat,setidCat]=useState()
    const [nombreUnidad,setNombredUnidad]=useState()
    const [idAct,setIdAct]=useState()
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (id,nombre,idUnidad,nomUnidad,idCat) =>{
        setShowEdit(true);
        setEditNombre(nombre);
        setidUnidad(idUnidad);
        setNombredUnidad(nomUnidad);
        setidCat(idCat);
        setIdAct(id);
    } 

    const getSubAct = async () => {
        const endpoint = uri+num;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setsubActividades(res.data);
                setTablaAct(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    useEffect(() => {
        const getSubAct = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,0);
            if(permiso){
                const endpoint = 'subActivities/'+num;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setsubActividades(res.data[0].subActividades);
                        setTablaAct(res.data[0].subActividades);
                        setUnidades(res.data[0].unidades);
                        setListSub(res.data[0].allSubActividades);
                        setNombreCat(res.data[0].nombreCat);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        };
        getSubAct();
    },[idUsuario,navigate,num]);

    const select = (id) => {
        sessionStorage.setItem("subAct", id);
        navigate("NivTrActividades");
    };
    
    const regresar = () => {
        navigate('/inicio/Catalogos/Actividades');
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaAct.filter((elemento)=> {
            if  (elemento.nombreSecond.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        })
        setsubActividades(resBusqueda);
    }

    const handleSelectChange = (event) =>{
        setUnidad(event.value);
    }

    const handleSelectChangeEdit = (event) =>{
        //console.log("valor "+event.value)
        setidUnidad(event.value);
    }

    //AGREGAR ACTIVIDAD
    const store = async (e) =>{
        e.preventDefault();
        setSaving(true);
        if(nombre.trim().length === "" || unidad === ""){
            warningToast('CAMPOS VACIOS','LLENAR TODOS LOS CAMPOS');
        }else{
            const num=parseInt(sessionStorage.getItem("catAct"));
            const data = {nombreAct:nombre,idCatAct:num,idUnidad:unidad};
            const endpoint = uri;
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getSubAct();
                    successToast("agregado");
                }else{
                    errorToast("¡error!", res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }

    //ELIMINAR ACTIVIDAD
    const eliminarAct = async (id) =>{
        const endpoint = 'validarChildrens/'+id+"/"+2;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if (res.data.message === "Esta categoría contiene actividades registradas") {
                errorToast("¡NO SE PUEDE ELIMINAR!",res.data.message);
            } else {
                warningModal('¿QUIERES ELIMINAR ESTA CATEGORIA?')
                .then(async (result)  => {
                    if (result.isConfirmed) {
                        const endpoint = 'eliminarAct/'+id+"/"+2;
                        const res = await deleteApi(endpoint);
                        if(res.status === 1){
                            if(res.data.message==="registro eliminado"){
                                getSubAct();
                                successToast("ELIMINADO");
                            }else{
                                errorToast("¡ERROR!",res.data.message);
                            }
                        }else if(res.status === 210){
                            navigate('/');
                        }else{
                            errorMessage(res.message);
                        }
                    }
                })
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    //EDITAR ACTIVIDAD
    const update= async (e) => {
        e.preventDefault()
        if(editNombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = 'updateSubActividad/'+idAct;
            const data = {nombreAct:editNombre,idCatAct:idCat,idUnidad:idUnidad};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getSubAct();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }

    const valorId=  idUnidad;
    const etiqueta = nombreUnidad;

    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">{nombreCat}</label>
                    </div>
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor"  onClick={handleShow} type="button">
                                <label className="agregar">ACTIVIDAD</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input type="search" placeholder="Nombre de la actividad" value={busqueda} onChange={buscar} className="form-control" style={{width:'50%'}} aria-describedby="basic-addon1"/> 
                        </div>
                    </div>
                    {subActividades.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                        <div className="tabla-cajaA" >
                            <div className="table tabla">
                                <table className="table table-hover table-bordered text-uppercase">
                                    <thead className="encabezado" style={{backgroundColor:"#365b77"}}>
                                        <tr >                                
                                            <th>CODIGO</th>
                                            <th >ACTIVIDAD</th>
                                            <th >UNIDAD</th>
                                            <th>EDITAR</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {subActividades.map(a =>{
                                            return(                                    
                                                <tr key={a.idSecond} >                                       
                                                    <td valign="middle" onClick={() => select(a.idSecond)}  as={Link} to={"NivTrActividades"}>{a.codigoSecond}</td>                                    
                                                    <td valign="middle" onClick={() => select(a.idSecond)}  as={Link} to={"NivTrActividades"}>{a.nombreSecond}</td> 
                                                    <td valign="middle" onClick={() => select(a.idSecond)}  as={Link} to={"NivTrActividades"}>{a.nombreUnidad}</td> 
                                                    <td>
                                                            <div className="btn iconoH"  onClick={() => handleShowEdit(a.idSecond,a.nombreSecond,a.idUnidad,a.nombreUnidad,a.cat_id)} style={{margin:'5px'}}>
                                                            <span className="bi bi-pen" title="EDITAR"></span>
                                                        </div>
                                                        <div className="btn iconoH" style={{margin:'5px'}} onClick={() => eliminarAct(a.idSecond)} >
                                                            <span className="bi bi-trash"  title="ELIMINAR"></span>
                                                        </div>
                                                    </td>  
                                                </tr>
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>      
                        </div>
                    )}
                </div>
            }

            {/*AGREGAR ACTIVIDAD*/}
            <Modal show={show} onHide={handleClose} id="modal-agregar-subActividad">
                <Modal.Header className=' btncolor'>
                    <Modal.Title>AGREGAR ACTIVIDAD</Modal.Title>
                    <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <form onSubmit={store}>
                    <div className="divO">
                        <label className="obligatorio">Obligatorio *</label>  
                    </div>
                    <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">BUSCAR</label>
                            <Select
                                classNamePrefix="select"
                                placeholder="Seleccionar actividad..."
                                defaultValue={listSub[0]}
                                required
                                options={listSub.map(act=>({label:act.codigoSecond+"-"+act.nombreSecond,value:act.idSecond}))}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="text-uppercase">NOMBRE
                            <label title="OBLIGATORIO" className="obligatorio">*</label> </label>
                            <input type="text" className="form-control"  required onChange={(e)=>setNombre(e.target.value)} aria-describedby="basic-addon1"/>   
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <Select
                                classNamePrefix="select"
                                placeholder="Seleccionar unidad..."
                                defaultValue={unidades[0]}
                                required
                                options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                onChange={handleSelectChange}
                            />
                        </div>   
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                        {isSaving===true? 
                            <Button className="btn btn-primary" type="button" disabled >
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </Button>:
                            <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                        }
                    </Modal.Footer>
                </form>
            </Modal>

            {/*EDITAR ACTIVIDAD*/}
            <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-subActividad">
                <Modal.Header className=' btncolor'>
                    <Modal.Title>EDITAR ACTIVIDAD</Modal.Title>
                    <CloseButton onClick={handleCloseEdit} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <form onSubmit={update}>
                    <div className="divO">
                        <label className="obligatorio">Obligatorio *</label>  
                    </div>
                    <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="text-uppercase">Actividad
                                <label title="OBLIGATORIO" className="obligatorio">*</label>
                            </label>
                            <input type="text" className="form-control"  required defaultValue={editNombre} onChange={(e)=>setEditNombre(e.target.value)} aria-describedby="basic-addon1"/>   
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <Select
                                defaultValue={{ label: etiqueta, value: valorId }}
                                required
                                options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                onChange={handleSelectChangeEdit}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                        {isSaving===true? 
                            <Button className="btn btn-primary" type="button" disabled >
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </Button>:
                            <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                        }
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
}

export default SubActividades;